"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ApplianceType extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'applianceType';
        this._name = initParams.name;
        this._applianceCategory = initParams.appliance_category;
        this._minutesLeadTime = initParams.minutes_lead_time;
        this._averageKwhPerHour = initParams.average_kwh_per_hour;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set applianceCategory(value) {
        console.error('Do not set objects this way');
    }
    get applianceCategory() {
        return this._applianceCategory;
    }
    set minutesLeadTime(value) {
        console.error('Do not set objects this way');
    }
    get minutesLeadTime() {
        return this._minutesLeadTime;
    }
    set averageKwhPerHour(value) {
        console.error('Do not set objects this way');
    }
    get averageKwhPerHour() {
        return this._averageKwhPerHour;
    }
}
exports.default = ApplianceType;
//# sourceMappingURL=applianceType.js.map